import React, { useEffect } from "react";
import styles1 from "../../styles/components/partnerSubmissionFeeModal.module.scss";
import assest from "../../json/assest";
import { Button } from "@imarabinda/antd";
import {
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import CustomSelectTwo from "../CustomSelectTwo/CustomSelectTwo";
import { useQuery } from "react-query";
import { ContentBuyerExpenses } from "../../api/functions/contentBuyer";
import ApiLoader from "../Loaders/ApiLoader";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyPdfDocument from "../PDFViewer/MyPdfDocument";
import HtmlToPdfConverter from "../HtmlToPdfConverter/HtmlToPDfConveter";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import ContentBuyerHtmlToPdfConverter from "../ContentBuyerHtmlToPdfConverter/ContentBuyerHtmlToPdfConverter";

const ContentBuyerAnalyticsBreakdown = ({
  buyer_id,
  contentBuyerSubmissions,
  name,
}) => {
  const [yearValue, setYearValue] = React.useState("");
  const [table1Data, setTable1Data] = React.useState([]);
  const [table2Data, setTable2Data] = React.useState([]);
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const [years, setYears] = React.useState([]);

  const handleChange1 = (event) => {
    setYearValue(event.target.value);
  };
  console.warn("yearValue", yearValue);
  const {
    data: contentBuyerExpencesData,
    isLoading,
    refetch,
    error,
  } = useQuery(["ContentBuyerExpenses", yearValue], async () =>
    ContentBuyerExpenses({
      user_id: buyer_id,
      year: yearValue,
    })
  );

  const monthIndices = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };
  useEffect(() => {
    const table1 = contentBuyerExpencesData?.filter(
      (item) => monthIndices[item.month] >= 0 && monthIndices[item.month] <= 5
    );
    const table2 = contentBuyerExpencesData?.filter(
      (item) => monthIndices[item.month] >= 6 && monthIndices[item.month] <= 11
    );

    setTable1Data(table1);
    setTable2Data(table2);
  }, [contentBuyerExpencesData]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYearValue(currentYear);

    const yearList = Array.from(
      { length: currentYear - 2020 },
      (_, index) => currentYear - index
    );

    setYears(yearList);
  }, []);

  return (
    <Box className={styles1.analyticsBreakdown}>
      {!isLoading ? (
        <Box className={styles1.analyticsBreakdownBody}>
          <h4>Payments breakdown</h4>
          <Box className={styles1.analysticYearSelect}>
            <CustomSelectTwo
              value={yearValue}
              onChange={handleChange1}
              displayEmpty
            >
              {/* <MenuItem value="">This year</MenuItem> */}
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year == new Date().getFullYear() ? "This year" : year}
                </MenuItem>
              ))}
            </CustomSelectTwo>
          </Box>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            className={styles1.breakDownRow}
          >
            <Box className={styles1.breakdownTableItem}>
              <Box className={styles1.breakdownTableBox}>
                <Box className={styles1.analyticsBreakdownHeader}>
                  <Button>January - June</Button>
                </Box>
                <Box className={styles1.analyticsBreakdownTable}>
                  <PerfectScrollbar>
                    <TableContainer>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className={styles1.month}>
                              Month
                            </TableCell>
                            <TableCell className={styles1.amount}>
                              Amount
                            </TableCell>
                            <TableCell className={styles1.payment}>
                              Payment Status
                            </TableCell>
                            <TableCell className={styles1.download}>
                              Download Report
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {table1Data?.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item?.month}</TableCell>
                              <TableCell>
                                {item?.count ? `$${item?.count}` : "-"}
                              </TableCell>
                              <TableCell>
                                {yearValue < currentYear ||
                                (yearValue === currentYear &&
                                  monthIndices[item.month] < currentMonth)
                                  ? "Completed"
                                  : yearValue < currentYear ||
                                    (yearValue === currentYear &&
                                      monthIndices[item.month] === currentMonth)
                                  ? "pending"
                                  : "-"}
                              </TableCell>
                              <TableCell>
                                {yearValue < currentYear ||
                                (yearValue === currentYear &&
                                  monthIndices[item.month] <= currentMonth) ? (
                                  <Button>
                                    <ContentBuyerHtmlToPdfConverter
                                      user_id={buyer_id}
                                      name={name}
                                      month={item?.month}
                                      year={yearValue}
                                      id={index}
                                    />
                                  </Button>
                                ) : (
                                  ""
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </PerfectScrollbar>
                </Box>
              </Box>
            </Box>

            <Box className={styles1.breakdownTableItem}>
              <Box className={styles1.breakdownTableBox}>
                <Box className={styles1.analyticsBreakdownHeader}>
                  <Button>July - December</Button>
                </Box>
                <Box className={styles1.analyticsBreakdownTable}>
                  <PerfectScrollbar>
                    <TableContainer>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className={styles1.month}>
                              Month
                            </TableCell>
                            <TableCell className={styles1.amount}>
                              Amount
                            </TableCell>
                            <TableCell className={styles1.payment}>
                              Payment Status
                            </TableCell>
                            <TableCell className={styles1.download}>
                              Download Report
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {table2Data?.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{item?.month}</TableCell>
                              <TableCell>
                                {item?.count ? `$${item?.count}` : "-"}
                              </TableCell>
                              <TableCell>
                                {yearValue < currentYear ||
                                (yearValue === currentYear &&
                                  monthIndices[item.month] < currentMonth)
                                  ? "Completed"
                                  : yearValue < currentYear ||
                                    (yearValue === currentYear &&
                                      monthIndices[item.month] === currentMonth)
                                  ? "Pending"
                                  : "-"}
                              </TableCell>
                              <TableCell>
                                {yearValue < currentYear ||
                                (yearValue === currentYear &&
                                  monthIndices[item.month] <= currentMonth) ? (
                                  <Button>
                                    <ContentBuyerHtmlToPdfConverter
                                      user_id={buyer_id}
                                      name={name}
                                      month={item?.month}
                                      year={yearValue}
                                      id={index}
                                    />
                                  </Button>
                                ) : (
                                  ""
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </PerfectScrollbar>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Box>
      ) : (
        <ApiLoader loading={isLoading} />
      )}
    </Box>
  );
};

export default ContentBuyerAnalyticsBreakdown;
